import { render, staticRenderFns } from "./liability.vue?vue&type=template&id=4da77992&scoped=true&"
import script from "./liability.vue?vue&type=script&lang=js&"
export * from "./liability.vue?vue&type=script&lang=js&"
import style0 from "./liability.vue?vue&type=style&index=0&id=4da77992&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da77992",
  null
  
)

export default component.exports